import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "developerHome" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "_dev" }, "Dev"),
  /*#__PURE__*/_createTextVNode("Home ")
], -1)
const _hoisted_5 = { class: "_main" }
const _hoisted_6 = { class: "_bodyRow _subheader" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Developer", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", null, "Welcome back, " + _toDisplayString(_ctx.$store.state.Auth.user.name), 1),
        _hoisted_7
      ])
    ])
  ]))
}